import { render, staticRenderFns } from "./BIM.vue?vue&type=template&id=0963bc10&scoped=true&"
import script from "./BIM.vue?vue&type=script&lang=js&"
export * from "./BIM.vue?vue&type=script&lang=js&"
import style0 from "./BIM.vue?vue&type=style&index=0&id=0963bc10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963bc10",
  null
  
)

export default component.exports